// Core
import React, { useState, useEffect } from "react";

// Components - Contrib Libraries
import { Alert, Button, Collapse } from "react-bootstrap";

// Components - Custom
import loader from "../assets/loading.gif";
import Header from "../components/headers";
import SearchBar from "../components/searchbar";
import FeaturedQuestion from "../components/featuredquestions";
import { fetchSubjectAreaDetails } from "../data/apis";
import { omniToggler } from "../assets/utilities";

function AlphaHeader(props) {
	const { subjectArea } = props;
	const { ID, related_link } = subjectArea;

	const [subjectAreaDetails, setSubjectAreaDetails] = useState();

	const [toggleCollapse, setToggleCollapse] = useState({});
	const [toggleAllCollapse, setToggleAllCollapse] = useState();

	const romans = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX"];

	useEffect(() => {
		(async () => {
			var response = await fetchSubjectAreaDetails(ID);
			var accordions = {};
			for (var item of response) {
				accordions[item.ID] = window.location.hash.includes("anchor") ? true : false;
			}
			setSubjectAreaDetails(response);
			setToggleCollapse(accordions);
		})();
	}, [ID]);

	function toggleAll() {
		var accordions = {};
		for (var item of subjectAreaDetails) {
			accordions[item.ID] = !toggleAllCollapse;
			setToggleAllCollapse(!toggleAllCollapse);
		}
		setToggleCollapse(accordions);
	}

	if (!subjectAreaDetails) {
		return (
			<div className="loader">
				<img src={loader} alt="loader" />
			</div>
		);
	}

	return (
		<>
			<h3 className="h4 mt-3" id="currentSA">
				{subjectArea.Site}
			</h3>
			<SearchBar subjectAreaID={subjectArea.ID} subjectAreaName={subjectArea.Site_Display_Name} />
			<FeaturedQuestion subjectArea_ID={ID} />
			<Alert variant="info" style={{ display: related_link ? "block" : "none" }} className="relatedInfo">
				<span dangerouslySetInnerHTML={{ __html: related_link }}></span>
			</Alert>

			<Alert variant="danger" id="brokenAnchorAlert" className="d-none">
				It seems like you landed on a question that has been removed or unpublished. To report a broken link, please{" "}
				<a href="/email.htm?flag=broken" target="_blank">
					E-mail OER Webmaster
				</a>
				.
			</Alert>

			<hr className="my-5" />

			<div className="faq-content ps-3">
				<div className="w-100 text-end mt-5 mb-3 d-none">
					<Button variant="link" onClick={omniToggler}>
						[Expand/Collapse Subject Area]
					</Button>
				</div>

				{subjectAreaDetails.map((item, i) => {
					const { ID, headers, AlphaHeaderText } = item;

					if (!AlphaHeaderText || AlphaHeaderText === "") {
						return <Header key={ID} headers={headers} lastAlphaHeaderLoaded={true} />;
					} else {
						return (
							<>
								{i === 0 && (
									<Button variant="link" onClick={toggleAll} className="toggler text-primary float-end ms-3 me-0">
										Expand/Collapse All AlphA Headers
									</Button>
								)}
								<div key={ID}>
									<div>
										<a
											href={window.location.hash.split("?")[0] + "?anchor=" + ID}
											className={"text-third panelTrigger " + toggleCollapse[ID]}
											onClick={(e) => {
												e.preventDefault();

												// Update URL with anchor every time the Question is cliked
												window.history.replaceState({}, "", window.location.hash.split("?anchor=")[0] + "?anchor=" + ID);
												setToggleCollapse({
													...toggleCollapse,
													[ID]: !toggleCollapse[ID],
												});
											}}
										>
											<span className="mx-3">{romans[i] + "."}</span>
											{AlphaHeaderText}
										</a>
										<Collapse in={toggleCollapse[ID]}>
											<div className="ps-4 position-relative">
												<Header headers={headers} lastAlphaHeaderLoaded={i + 1 === subjectAreaDetails.Details.length} />
											</div>
										</Collapse>
									</div>
								</div>
							</>
						);
					}
				})}
			</div>
		</>
	);
}

export default AlphaHeader;
